// https://www.youtube.com/watch?v=ivtbRBEjLW8&t=368s
// 16.42 хв
import { initializeApp } from 'firebase/app';
import {
  doc,
  updateDoc,
  getFirestore,
  getDoc,
  getDocs,
  query,
  where,
  orderBy,
  limit,
  collection,
  onSnapshot,
  addDoc,
  setDoc,
  arrayUnion,
  arrayRemove,
  deleteDoc,
  deleteField,
} from 'firebase/firestore';
import { generateRandomString } from './helper';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKED,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_API_ID,
};

export const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

// =====================================================================

// -------------- Додає дані ------------------------
export const addDocBd = async (collection, document, value) => {
  try {
    await setDoc(doc(db, collection, document), value);
    return true;
  } catch {
    return false;
  }
};
// -------------- /Додає дані ------------------------

// -------------- Видаляє дані ------------------------
export const deleteDocBd = async (collection, id) => {
  try {
    await deleteDoc(doc(db, collection, id));

    return true;
  } catch (e) {
    return false;
  }
};
// -------------- /Видаляє дані ------------------------

// -------------- Отримує дані ------------------------
export const getDocBd = async (collection, document) => {
  const docRef = doc(db, collection, document);
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    return docSnap.data();
  } else {
    return false;
  }
};

// -------------- /Отримує дані ------------------------

// -------------- Редагує дані ------------------------

export const updateDocBd = async (collection, document_id, item, value) => {
  const clientNotesRef = doc(db, collection, document_id);

  try {
    await updateDoc(clientNotesRef, {
      [item]: value,
    });

    return true;
  } catch {
    return false;
  }
};
// -------------- /Редагує дані ------------------------
